import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, SharedService } from "../../services";
import { TokenValue } from "src/app/models";

@Component({
  selector: "app-external-login",
  templateUrl: "./external-login.component.html",
  styleUrls: ["./external-login.component.scss"]
})
export class ExternalLoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private router: Router, 
    private authService: AuthService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(queryStringParams =>{
      var token = queryStringParams["token"];
      var expiresIn = queryStringParams["expiresIn"];
      var expiresAt = queryStringParams["expiresAt"];
      var dataLogicalCorpIdBranchAndCustId = queryStringParams["tokenUsername"];
      var corpId = queryStringParams["corpId"];
      var branchCustid = queryStringParams["branchCustId"];
      var dataLogical = queryStringParams["dataLogical"];

      var tokenValue: TokenValue =
      {
        access_token: token,
        token_type: "bearer",
        expires_in: expiresIn,
        username: dataLogicalCorpIdBranchAndCustId,
        company_id: corpId,
        name: branchCustid,
        passwordMeetsRequirements: "True",
        logical: dataLogical,
        ".expires": expiresAt,
        ".issued": null,
        isCompany: false
      };
      this.authService.setSession(tokenValue);
      this.sharedService.isExternalLoginInstance = true;
      this.router.navigate(["home"]);
    });
  }

}
